import Loading from '../../../Common/Loading';
import { FamilyBreachsOfConditionsAnual } from './FamilyBreachsOfConditionsAnual';
import { FamilyBreachsOfConditionsMonthly } from './FamilyBreachsOfConditionsMonthly';
import { ChildrenSchoolAttendanceComparisonAnual } from './ChildrenSchoolAttendanceComparisonAnual';
import { ChildrenSchoolAttendanceComparisonMonthly } from './ChildrenSchoolAttendanceComparisonMonthly';
import { ChildrenSchoolAttendanceComparisonPercentageAnual } from './ChildrenSchoolAttendanceComparisonPercentageAnual';
import { ChildrenSchoolAttendanceComparisonPercentageMonthly } from './ChildrenSchoolAttendanceComparisonPercentageMonthly';
import { WithInformedHealthConditionsComparisonAnual } from './WithInformedHealthConditionsComparisonAnual';
import { WithInformedHealthConditionsComparisonMonthly } from './WithInformedHealthConditionsComparisonMonthly';
import { WithInformedHealthConditionsComparisonPercentageAnual } from './WithInformedHealthConditionsComparisonPercentageAnual';
import { WithInformedHealthConditionsComparisonPercentageMonthly } from './WithInformedHealthConditionsComparisonPercentageMonthly';
import { ProfileCadUnicoComparisonAnual } from './ProfileCadUnicoComparisonAnual';
import { ProfileCadUnicoComparisonMonthly } from './ProfileCadUnicoComparisonMonthly';
import { ProfileCadUnicoComparisonPercentageAnual } from './ProfileCadUnicoComparisonPercentageAnual';
import { ProfileCadUnicoComparisonPercentageMonthly } from './ProfileCadUnicoComparisonPercentageMonthly';
import { useConditionalityChartsDataContext } from './hooks/useConditionalityChartsDataContext';

export const Charts = () => {
    const { isLoading } = useConditionalityChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="chats-indicators-side-by-side-dashboards">
                <FamilyBreachsOfConditionsAnual />
                <FamilyBreachsOfConditionsMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <ChildrenSchoolAttendanceComparisonAnual />
                <ChildrenSchoolAttendanceComparisonMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <ChildrenSchoolAttendanceComparisonPercentageAnual />
                <ChildrenSchoolAttendanceComparisonPercentageMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <WithInformedHealthConditionsComparisonAnual />
                <WithInformedHealthConditionsComparisonMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <WithInformedHealthConditionsComparisonPercentageAnual />
                <WithInformedHealthConditionsComparisonPercentageMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <ProfileCadUnicoComparisonAnual />
                <ProfileCadUnicoComparisonMonthly />
            </div>
            <div className="chats-indicators-side-by-side-dashboards">
                <ProfileCadUnicoComparisonPercentageAnual />
                <ProfileCadUnicoComparisonPercentageMonthly />
            </div>                 
        </>
    );
};
